import BlogDetailsPage from "./blog-details.page"

export default BlogDetailsPage;
